import { CopyMetadataFromParent, Property } from '@skylab-shared/core';
import { DocumentItemModel } from '../document/document-item.model';

@CopyMetadataFromParent()
export class PurchaseInvoiceDocumentItemModel extends DocumentItemModel {
    @Property({ nullable: true })
    public inventoryUnitCost?: number;

    @Property({ nullable: true })
    public inventoryTotalCost?: number;

    @Property()
    public relatedInventoryItemsIds: number[];

    @Property()
    public includesInventoryControl: boolean;

    @Property({nullable: true})
    public zal15: boolean;

    @Property({nullable: true})
    public index: string;

    @Property(Number, {nullable: true})
    public adjustedItemId: number | null;

    //helpers For creating from eInvoice
    public itemFromEInvoice: boolean;
    public originalEInvoiceSymbol: string;
}
